import React from 'react';
import { Mail } from 'lucide-react';

const ContactHero = () => {
  return (
    <section className="pt-32 pb-16 px-6 bg-gradient-to-b from-gray-900 to-gray-950">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-900/30 border border-blue-700 rounded-full mb-6">
          <Mail className="w-4 h-4 text-blue-400" />
          <span className="text-sm text-blue-300 font-medium">Get in Touch</span>
        </div>
        
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Let's Talk About Your Team
        </h1>
        
        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
          Have questions about Traain? Want to see a demo? Our team is here to help you transform your training and enablement processes.
        </p>
      </div>
    </section>
  );
};

export default ContactHero;